import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ConfirmationDialog } from '@dhl/confirmation-dialog'
import { Body1, Grid } from '@dhl-ui/components'
import { links } from '~/AppRoutes'

export type ApiCredentialsDialogData = {
  id?: string
  clientId?: string
  clientSecret?: string
}
type Props = {
  open: boolean
  onClose: () => void
  id?: string
  clientId?: string
  clientSecret?: string
}

export const APICredentialsDialog = ({
  open,
  id: pId,
  clientId: pClientId,
  clientSecret: pClientSecret,
  onClose,
}: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { id = pId, clientId = pClientId, clientSecret = pClientSecret } = useParams<ApiCredentialsDialogData>()
  return (
    <ConfirmationDialog
      open={open}
      titleText={t('admin.apiCredentialsDialog.title')}
      acceptText={t('admin.apiCredentialsDialog.gotItButton')}
      rejectText={''}
      onAccept={() => {
        onClose()
        if (id) {
          navigate(links.organisationDetailsLink(id))
        } else {
          navigate(links.integratorDetailsLink(id!))
        }
      }}
      onReject={() => {
        onClose()
        navigate(links.integratorDetailsLink(id!))
      }}
    >
      <Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="center">
        <Grid size={12}>
          <Body1>Client ID:</Body1>
        </Grid>
        <Grid size={12}>
          <Body1>{clientId}</Body1>
        </Grid>
      </Grid>

      <Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="center">
        <Grid size={12}>
          <Body1>Client secret:</Body1>
        </Grid>
        <Grid size={12}>
          <Body1>{clientSecret}</Body1>
        </Grid>
      </Grid>
    </ConfirmationDialog>
  )
}
